<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="supplierAddEditForm">
      <div class="field-validation-error"></div>
      <div class="row">
        <div class="col-sm-12">
          <div class="required" aria-required="true">
            <div class="services-form">
              <input formControlName="name" type="text" maxlength="50" placeholder="Name" />
              <label>Name</label>
              <div
                *ngIf="
                  (submitted || supplierAddEditForm.controls['name'].touched) &&
                  supplierAddEditForm.controls['name'].errors
                "
              >
                <div
                  *ngIf="supplierAddEditForm.controls['name'].errors?.['required']"
                  class="input-error"
                >
                  Name is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn" (click)="onSave()">Save</button>
  </div>
</div>
